import { useState, useEffect } from 'react';
import { fundraiserUserService } from '../services/fundraiserService';

export const useFundraiserStatus = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        setLoading(true);
        const status = await fundraiserUserService.getStatus();
        setIsEnabled(status.enabled);
      } catch {
        setIsEnabled(false);
      } finally {
        setLoading(false);
      }
    };
    check();
  }, []);

  return { isEnabled, loading };
};
